import dayjs from 'dayjs';
import { STATUSES } from '../assets/statuses';
import { getStatusDisplay, StatusDisplayEnum } from '../utils/getStatusDisplay';

type StatusDisplayProps = {
  isDirty: boolean;
  lastUpdated: string;
  isManuallyUpdated?: boolean;
};

/**
 * A reusable component for displaying status with icon and timestamp
 * @param isDirty - whether the item is dirty
 * @param lastUpdated - The last updated date string
 * @param isManuallyUpdated - Whether the item is manually updated
 */
export const StatusDisplay = ({
  isDirty,
  lastUpdated,
  isManuallyUpdated = false,
}: StatusDisplayProps) => {
  const status = getStatusDisplay(isDirty || isManuallyUpdated, lastUpdated);
  const Icon = STATUSES[status] || null;
  const isValidDate = dayjs(lastUpdated).isValid();
  const isNotStarted = status === StatusDisplayEnum.NotStarted;

  return (
    <span className="custom-table--column flex items-center gap-4">
      {Icon}{' '}
      {isValidDate && !isNotStarted
        ? `${isManuallyUpdated ? 'Manually updated' : 'Updated'} ${dayjs(
            lastUpdated,
          ).fromNow()}`
        : 'Not Started'}
    </span>
  );
};
